
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("8LitS"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("3B3F8"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _42Yu6BsWIj",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $cozmU.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $cozmU.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("8LitS", function(module, exports) {

let $66110c6cda0675dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $66110c6cda0675dd$var$load("ayJxT"),
    $66110c6cda0675dd$var$load("fdsim")
]).then(()=>parcelRequire('jgOPc'));

});

parcelRegister("3B3F8", function(module, exports) {

let $29e7ab1061aa9b43$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $29e7ab1061aa9b43$var$load("kT6dz"),
    $29e7ab1061aa9b43$var$load("2NNfQ"),
    $29e7ab1061aa9b43$var$load("6dLts"),
    $29e7ab1061aa9b43$var$load("jdPbE"),
    $29e7ab1061aa9b43$var$load("35mvB"),
    $29e7ab1061aa9b43$var$load("lkHIj"),
    $29e7ab1061aa9b43$var$load("b8BFA"),
    $29e7ab1061aa9b43$var$load("fAvNQ"),
    $29e7ab1061aa9b43$var$load("hUbK8"),
    $29e7ab1061aa9b43$var$load("iVMOQ"),
    $29e7ab1061aa9b43$var$load("alg5Q"),
    $29e7ab1061aa9b43$var$load("8yk9S"),
    $29e7ab1061aa9b43$var$load("iOfkQ"),
    $29e7ab1061aa9b43$var$load("5KHgm"),
    $29e7ab1061aa9b43$var$load("fcAaN"),
    $29e7ab1061aa9b43$var$load("7oMW2"),
    $29e7ab1061aa9b43$var$load("bRoHi"),
    $29e7ab1061aa9b43$var$load("aGwmo"),
    $29e7ab1061aa9b43$var$load("7q87y"),
    $29e7ab1061aa9b43$var$load("1Gr4q"),
    $29e7ab1061aa9b43$var$load("lfFFf"),
    $29e7ab1061aa9b43$var$load("kccW9"),
    $29e7ab1061aa9b43$var$load("ixpi4"),
    $29e7ab1061aa9b43$var$load("e95jE"),
    $29e7ab1061aa9b43$var$load("cKPFM"),
    $29e7ab1061aa9b43$var$load("dChty"),
    $29e7ab1061aa9b43$var$load("7SteV"),
    $29e7ab1061aa9b43$var$load("1cQg7"),
    $29e7ab1061aa9b43$var$load("4aKct"),
    $29e7ab1061aa9b43$var$load("dxcsb"),
    $29e7ab1061aa9b43$var$load("jqoep"),
    $29e7ab1061aa9b43$var$load("cN2rp"),
    $29e7ab1061aa9b43$var$load("Xi5vc"),
    $29e7ab1061aa9b43$var$load("ekdqM"),
    $29e7ab1061aa9b43$var$load("iqLRv"),
    $29e7ab1061aa9b43$var$load("6vufR"),
    $29e7ab1061aa9b43$var$load("fKQ9j"),
    $29e7ab1061aa9b43$var$load("keazL"),
    $29e7ab1061aa9b43$var$load("dhXIT"),
    $29e7ab1061aa9b43$var$load("ea3NB"),
    $29e7ab1061aa9b43$var$load("6wr18"),
    $29e7ab1061aa9b43$var$load("59hV4"),
    $29e7ab1061aa9b43$var$load("9zpfi"),
    $29e7ab1061aa9b43$var$load("9pNir"),
    $29e7ab1061aa9b43$var$load("ffEVr"),
    $29e7ab1061aa9b43$var$load("do0Fh"),
    $29e7ab1061aa9b43$var$load("7BHAC"),
    $29e7ab1061aa9b43$var$load("N3TvS"),
    $29e7ab1061aa9b43$var$load("dIY7W"),
    $29e7ab1061aa9b43$var$load("8lMr1"),
    $29e7ab1061aa9b43$var$load("1vUE6"),
    $29e7ab1061aa9b43$var$load("f0CsL"),
    $29e7ab1061aa9b43$var$load("56OxX"),
    $29e7ab1061aa9b43$var$load("fwbNS"),
    $29e7ab1061aa9b43$var$load("Wowvf"),
    $29e7ab1061aa9b43$var$load("4g6rd"),
    $29e7ab1061aa9b43$var$load("7A87G"),
    $29e7ab1061aa9b43$var$load("hhss7"),
    $29e7ab1061aa9b43$var$load("7EorR"),
    $29e7ab1061aa9b43$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.f917e643.js.map
